const _timeouts = []
const _addTimeouts = []
const timeContext = window.performance || Date 

/**
 * Retrieves the execution-stack.
 */
export function getTimeouts() {
  return _timeouts
}

export function updateTimeouts(_delta) {
  let delta = _delta

  while (_timeouts.length > 0) {
    const remaining = _timeouts[0].update(delta)
    if (remaining > 0) {
      break
    } else {
      delta = -remaining
    }
  }
}


export function addPendingTimeouts(delta, gamespeed, timeStamp) {
  while (_addTimeouts.length) {
    addTimeout(_addTimeouts.pop(), delta, gamespeed, timeStamp)
  }
}

/**
 * Cancels a timeout and removes it from the execution stack.
 * @param {Timeout} timeout - The timeout to cancel.
 * @returns {Number} - The time remaining, before the timeout was cancelled.
 */
export function cancelTimeout(timeout) {
  let index = _timeouts.indexOf(timeout)
  if (index >= 0) {
    let remainingTime = timeout.time || 0
    let i = index
    while (i--) {
      remainingTime += _timeouts[i].time
    }
    const next = _timeouts[index + 1]
    if (next) {
      next.time += timeout.time
    }
    _timeouts.splice(index, 1)
    delete timeout.callback
    delete timeout.time
    return remainingTime
  } else {
    index = _addTimeouts.indexOf(timeout)
    if (index >= 0) {
      _addTimeouts.splice(index, 1)
    }
    return timeout.time
  }

  return 0
}

function addTimeout(timeout, delta, gamespeed, timeStamp) {

  let i = 0
  const startDelta = ((timeStamp - timeout._timeAdded) * gamespeed)
  timeout.time = timeout.time + (delta - startDelta)

    let acc = 0
    for (; i < _timeouts.length; i++) {
      const newAcc = acc + _timeouts[i].time
      if (newAcc > timeout.time) {
        _timeouts[i].time = newAcc - timeout.time
        break
      }
      acc = newAcc
    }
    timeout.time = timeout.time - acc

  _timeouts.splice(i, 0, timeout)
}

/**
 * Creates a timeout that runs in the internal-gameloop.
 * When the game pauses it pauses
 */
export default class Timeout {
  /**
   * Create a new timeout.
   * @param {function} callback - The function that will be called once done.
   * @param {number} time - the minimum time (ms) the timeout will last.
   */
  constructor(callback, time) {
    this.time = time
    this.callback = callback
    this._timeAdded = timeContext.now()

    _addTimeouts.push(this)
  }
  /**
   * Updates the timeout and executes the "callback" once ready.
   * @param {number} delta - The delta that will be used to calculate the remaining time.
   */
  update(delta) {
    this.time -= delta

    if (this.time <= 0) {
      _timeouts.shift()
      this.callback()
      delete this.callback
    }

    return this.time
  }
  /**
   * Cancels the timeout and removes it from the execution stack.
   * @returns {Number} - Returns the time remaining before the timeout was cancelled.
   */
  cancel() {
    return cancelTimeout(this)
  }
}
